// src/belediye/services/internalTasksApi.js
// FAZ-28 — Kurum İçi Görevler uçları.
//
// KURAL (07 §3): görünürlük KİMLİKTEN — bu uçlara X-Unit-Slug GÖNDERİLMEZ
// (belediyeApi isNoUnitHeaderEndpoint muafiyeti). Ek dosyaları için ham /media/
// yolu YOKTUR; indirme yalnız gated download_url üzerindendir.

import api from "./belediyeApi";

const clean = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );

// ── Listeler / sayaçlar ────────────────────────────────────────────────
export const fetchTasks = (params = {}) =>
  api.get("/internal-tasks/tasks/", { params: clean(params) }).then((r) => r.data);

// FAZ-57: sayaçlar artık listenin gördüğü kümeyi sayar — arama ve filtreler de
// gönderilir. Parametresiz çağrı (sidebar rozeti) eski davranışı korur.
export const fetchCounters = (scope, params = {}) =>
  api
    .get("/internal-tasks/tasks/counters/", { params: clean({ scope, ...params }) })
    .then((r) => r.data);

export const fetchRecentTargets = () =>
  api.get("/internal-tasks/recent-targets/").then((r) => r.data);

export const searchAssignableTargets = (q = "") =>
  api
    .get("/internal-tasks/assignable-targets/", { params: q ? { q } : {} })
    .then((r) => r.data);

// ── CRUD / aksiyonlar ──────────────────────────────────────────────────
export const fetchTaskDetail = (id) =>
  api.get(`/internal-tasks/tasks/${id}/`).then((r) => r.data);

export const createTask = (payload) =>
  api.post("/internal-tasks/tasks/", payload).then((r) => r.data);

export const updateTask = (id, payload) =>
  api.patch(`/internal-tasks/tasks/${id}/`, payload).then((r) => r.data);

// FAZ-114 — TALEBİ SİL (yumuşak silme; kayıt denetim için durur).
// `taskAction` KULLANILMAZ: silme bir POST aksiyonu değil, kaynağın kendisine
// yapılan DELETE'tir ve 204 döner (gövde yok). Aksiyon kalıbına sokmak, dönen
// talebi işleyen ortak koda "artık görünmeyen" bir kaydı okutmaya çalışırdı.
export const deleteTask = (id) =>
  api.delete(`/internal-tasks/tasks/${id}/`).then(() => true);

// action: accept | start | complete | reopen | cancel | assign | unassign
// FAZ-55/15 — KRİTİK DÜZELTME. Backend aksiyon uçları TİRELİ (`close-confirm`,
// `request-changes` — DRF `url_path`), çağıranlar ise Python komut adlarını
// (`close_confirm`, `request_changes`) yolluyordu → 404 → arayüzde "İşlem
// yapılamadı." Yani "Onayla ve kapat" / "Düzeltme iste" HİÇ çalışmıyordu; bu
// bir YETKİ sorunu değildi (roller yetkiliydi), yol sorunuydu.
// Alt çizgi → tire dönüşümü burada TEK yerde yapılır; her iki yazım da çalışır.
export const taskAction = (id, action, body = {}) =>
  api
    .post(`/internal-tasks/tasks/${id}/${String(action).replace(/_/g, "-")}/`, body)
    .then((r) => r.data);

export const addComment = (id, body, setWaiting = false) =>
  api
    .post(`/internal-tasks/tasks/${id}/comment/`, { body, set_waiting: setWaiting })
    .then((r) => r.data);

export const askStatus = (id, question = "") =>
  api
    .post(`/internal-tasks/tasks/${id}/ask-status/`, { question })
    .then((r) => r.data);

// ── Ekler (fotoğraf) ───────────────────────────────────────────────────
export const uploadAttachment = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/internal-tasks/tasks/${id}/attachments/`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const deleteAttachment = (attachmentId) =>
  api.delete(`/internal-tasks/attachments/${attachmentId}/`);

// ── Başvuru köprüsü (FAZ-29) ───────────────────────────────────────────
export const fetchByApplication = (applicationId) =>
  api.get(`/internal-tasks/by-application/${applicationId}/`).then((r) => r.data);

// NOT: "Görev Raporu" (özet + XLSX dışa aktarım) 2026-07-28'de tümüyle
// kaldırıldı — sayfa, rota, uçlar ve izin kodları dâhil. Buraya bir
// `fetchReportSummary` eklemeden önce o kararın hâlâ geçerli olduğunu doğrula.

